import { ACCACCOUNT_LOADING, GET_ACCACCOUNT, GET_ACCACCOUNT_SUCCESS, GET_ACCACCOUNT_FAIL, ADD_ACCACCOUNT_SUCCESS, ADD_ACCACCOUNT_FAIL, DELETE_ACCACCOUNT_SUCCESS, DELETE_ACCACCOUNT_FAIL, UPDATE_ACCACCOUNT_SUCCESS, UPDATE_ACCACCOUNT_FAIL, ACCACCOUNT_RESET, GET_ACCACCOUNT_ONE } from "./actionType";

const INIT_STATE = {
  accAccounts: [],
  accAccount: {},
  error: {},
};

const AccAccount = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ACCACCOUNT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ACCACCOUNT:
          return {
            ...state,
            accAccounts: action.payload.data,
            isAccAccountCreated: false,
            isAccAccountSuccess: true,
            loading: false,
          };

        case GET_ACCACCOUNT_ONE:
          return {
            ...state,
            accAccount: action.payload.data,
            isAccAccountSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ACCACCOUNT_FAIL:
      switch (action.payload.actionType) {
        case GET_ACCACCOUNT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAccAccountCreated: false,
            isAccAccountSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ACCACCOUNT: {
      return {
        ...state,
        isAccAccountCreated: false,
        loading: true,
      };
    }

    case GET_ACCACCOUNT_ONE: {
      return {
        ...state,
        loading: true,
      };
    }

    case ACCACCOUNT_LOADING: {
      return {
        ...state,
        isAccAccountCreated: false,
        loading: true,
      };
    }

    case ADD_ACCACCOUNT_SUCCESS:
      return {
        ...state,
        isAccAccountCreated: true,
        loading: false,
        accAccounts: [action.payload.data, ...state.accAccounts],
      };

    case ADD_ACCACCOUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ACCACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        isAccAccountCreated: true,
        accAccounts: state.accAccounts.filter((accAccount) => accAccount.id.toString() !== action.payload.id.toString()),
      };

    case DELETE_ACCACCOUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ACCACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        isAccAccountCreated: true,
        accAccounts: state.accAccounts.map((accAccount) => (accAccount.id.toString() === action.payload.data.id.toString() ? { ...accAccount, ...action.payload.data } : accAccount)),
      };

    case UPDATE_ACCACCOUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACCACCOUNT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AccAccount;
